"use client";
import { useState } from "react";
import "./swiper/hero.css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import Image from "next/image";
import { Button } from "../ui/button";
import { GlareCard } from "../ui/glare-card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import AnimationContainer from "../utils/animation-container";

const slides = [
    {
        image: "/images/assasins.jpg",
        title: "بازی Assassin's Creed Mirage",
        description: "ماجراجویی جدید در بغداد! وارد دنیای پر رمز و راز اساسین‌ها شوید و داستان باسیم ابن اسحاق را تجربه کنید.",
        thumbnails: [
            "/images/assasins2.jpg",
            "/images/assasins3.jpg",
            "/images/assasins4.jpg",
            "/images/assasins.jpg",
        ],
    },
    {
        image: "/images/slide2.jpg",
        title: "بازی Far Cry 6",
        description: "در دنیای باز یارا، با دیکتاتور ظالم به مبارزه بپردازید و برای آزادی بجنگید!",
        thumbnails: [
            "/images/slide3.jpg",
            "/images/slide4.jpg",
            "/images/slide5.jpg",
            "/images/slide6.jpg",
        ],
    },
    {
        image: "/images/borderlands.jpg",
        title: "بازی Borderlands 3",
        description: "یک بازی شوتر هیجان‌انگیز پر از اسلحه‌های عجیب و دشمنان دیوانه!",
        thumbnails: [
            "/images/borderlands2.jpg",
            "/images/borderlands3.jpg",
            "/images/borderlands4.jpg",
            "/images/borderlands5.jpg",
        ],
    },
    {
        image: "/images/cod3.jpg",
        title: "بازی Call of Duty: Modern Warfare III",
        description: "نبردهای پرسرعت و داستانی نفس‌گیر در جدیدترین نسخه از کالاف دیوتی!",
        thumbnails: [
            "/images/cod.jpg",
            "/images/cod2.jpg",
            "/images/cod2.png",
            "/images/cod4.jpg",
        ],
    },
    {
        image: "/images/nfs.jpg",
        title: "بازی Need for Speed: Heat",
        description: "وارد مسابقات خیابانی شوید و برای سلطه بر جاده‌ها تلاش کنید!",
        thumbnails: [
            "/images/nfs2.png",
            "/images/nfs3.png",
            "/images/nfs4.jpg",
            "/images/nfs.jpg",
        ],
    },
    {
        image: "/images/elden2.jpg",
        title: "بازی Elden Ring",
        description: "در دنیایی پهناور و چالش‌برانگیز، به عنوان یک Tarnished افسانه‌ای سفر کنید!",
        thumbnails: [
            "/images/elden2.jpg",
            "/images/elden3.jpg",
            "/images/elden4.jpg",
            "/images/elden5.jpg",
        ],
    },
];

const Hero = () => {
    return (
        <div className="w-full flex flex-col gap-2">
            <div className="lg:hidden flex justify-between items-center px-6 md:px-28 p-5">
                <div className="flex items-center gap-2">
                    <div className="bg-gradient-to-r from-violet-500 to-purple-500 w-10 h-10 flex items-center justify-center rounded-xl">
                        <p lang="en" className="text-3xl">B</p>
                    </div>
                    <div>
                        <p className="font-bold">بهترین بازی‌ها</p>
                        <p className="text-xs">بهترین تجربه گیمینگ با جدیدترین بازی‌ها</p>
                    </div>
                </div>
                <Button className="bg-[#4E0CD4]" variant='secondary' size='sm'>مشاهده</Button>
            </div>

            <AnimationContainer className="w-full h-auto p-5 md:p-0">
                <Swiper
                    initialSlide={0}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={"auto"}
                    spaceBetween={30}
                    loop={true}
                    autoplay={{
                        delay: 10000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    modules={[Autoplay]}
                    dir="ltr"
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index} className="magic-slider">
                            <SlideContent slide={slide} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </AnimationContainer>
        </div>
    );
};

const SlideContent = ({ slide }: any) => {
    const [currentImage, setCurrentImage] = useState(slide.image);

    return (
        <div className="w-full flex flex-col lg:flex-row gap-6 items-center">
            <div className="w-full lg:w-2/3 flex justify-center">
                <div className="w-full max-w-screen-lg">
                    <Image
                        src={currentImage}
                        layout="intrinsic"
                        width={1000}
                        height={600}
                        alt={slide.title}
                        className="w-full h-auto max-h-[500px] lg:min-h-[500px] min-h-[200px] object-cover rounded-lg shadow-md transition-opacity duration-300 ease-in-out"
                    />
                </div>
            </div>

            <div className="w-full lg:w-1/3 flex flex-col justify-start items-start gap-2 lg:gap-12">
                <h2 className="lg:text-2xl text-md md:text-xl font-semibold text-center lg:text-start">
                    {slide.title}
                </h2>
                <div className="flex flex-col items-start gap-3">
                    <div className="hidden lg:grid grid-cols-2 gap-3">
                        {slide.thumbnails.map((thumb: any, idx: any) => (
                            <div
                                key={idx}
                                className="cursor-pointer"
                                onMouseEnter={() => setCurrentImage(thumb)}
                                onMouseLeave={() => setCurrentImage(slide.image)}
                            >
                                <GlareCard className="rounded-md overflow-hidden shadow">
                                    <Image
                                        src={thumb}
                                        layout="intrinsic"
                                        width={150}
                                        height={80}
                                        alt={`تصویر کوچک از ${slide.title}`}
                                        className="min-w-[150px] max-w-[150px] max-h-[80px] min-h-[80px] object-cover transition-transform duration-300 hover:scale-105"
                                    />
                                </GlareCard>
                            </div>
                        ))}
                    </div>
                    <p className="text-sm text-gray-500 text-start w-auto lg:w-[300px]">
                        {slide.description}
                    </p>
                </div>
                <div className="hidden lg:flex justify-center lg:justify-start">
                    <Button variant="secondary">ادامه مطلب</Button>
                </div>
            </div>
        </div>
    );
};

export default Hero;
